import React from "react";

function WORM_GEAR_HIGHER_SERIES() {
  return (
    <>
      <div className="container p-5">
        <h1>WORM GEAR HIGHER SERIES </h1>
        <hr></hr>
        <div className="row">
          <div className="col-md-5">
            <img src="./images/ProImages/WORM-GEAR-HIGHER-SERIES.png"></img>
          </div>

          <div className="col-md-7 mt-5">
            <p className="fs-1">
              <b> Underdriven </b> : SFU
            </p>
            <p className="fs-1">
              {" "}
              <b>Overdriven</b> : SFO
            </p>
            <p className="fs-1">
              {" "}
              <b>Verticle output shaft up/down</b> : SFV
            </p>
            <p className="fs-1">
              {" "}
              <b>Hollow output shaft</b> : SSM
            </p>
            <p className="fs-1">
              {" "}
              <b>Sizes </b> : 10”  to 17”
            </p>
            <p className="fs-1">
              {" "}
              <b>Ratio </b> :	Min. 5 : 1 to Max 70 : 1
            </p>
            <p className="fs-1">
              {" "}
              <b>Power Capacity </b> :	350 kW
            </p>
            	
          </div>
        </div>
      </div>
    </>
  );
}

export default WORM_GEAR_HIGHER_SERIES;
